(function () {
    'use strict';

    function isUndefined(v) {
        return typeof v === "undefined";
    }

    var accessors = new TS.HashTable();

    $.extend(TS, {
        getPropertyValue: function (object, property, raw) {
            var ds = object,
                part,
                parts = (property || '').split('.'),
                partsLength = parts.length;

            if (typeof ds === 'undefined' || ds === null) {
                return null;
            }
            if (ts.isFunction(ds['getPropertyValue'])) {
                return ds.getPropertyValue(property);
            }

            for (var partIndex = 0; partIndex < partsLength; partIndex++) {
                part = parts[partIndex];
                if (part.indexOf('()') == part.length - 2) {
                    part = part.substr(0, part.length - 2);
                }

                if(raw !== true || partIndex < partsLength - 1) {
                    ds = ko.valueOf(ds[part]);
                }
                else {
                    ds = ds[part];
                }
                //this part does not exist, no need to continue
                if (typeof ds === 'undefined' || ds === null) {
                    return null;
                }
                if (ts.isFunction(ds['getPropertyValue'])) {
                    return ds.getPropertyValue(parts.slice(partIndex + 1).join('.'));
                }
            }
            return ds;
        },

        setPropertyValue: function (object, property, value) {
            var ds = object,
                part,
                parts = (property || '').split('.'),
                partsLength = parts.length;

            if (typeof ds === 'undefined' || ds === null) {
                return;
            }
            if (ts.isFunction(ds['setPropertyValue'])) {
                return ds.setPropertyValue(property, value);
            }

            for (var partIndex = 0; partIndex < partsLength - 1; partIndex++) {
                part = parts[partIndex];
                if (part.indexOf('()') == part.length - 2) {
                    part = part.substr(0, part.length - 2);
                }
                ds = ko.valueOf(ds[part]);
                //this part does not exist, no need to continue
                if (typeof ds === 'undefined' || ds === null) {
                    return;
                }
                if (ts.isFunction(ds['setPropertyValue'])) {
                    return ds.setPropertyValue(parts.slice(partIndex + 1).join('.'), value);
                }
            }

            part = parts[partsLength - 1];
            if (ko.isObservable(ds[part])) {
                if (ko.isWriteableObservable(ds[part])) {
                    ds[part](value);
                }
            } else {
                ds[part] = value;
            }
        },

        accessor: function (dataSource, propertyPath, handler) {
            var dsPaths = accessors.get(dataSource),
                handlerKey = '__default',
                handlers,
                prop;

            if (isUndefined(dsPaths)) {
                dsPaths = [];
                accessors.add(dataSource, dsPaths);
            }

            handlers = dsPaths[propertyPath];

            if (isUndefined(handlers)) {
                dsPaths[propertyPath] = handlers = new TS.HashTable();
            }

            if (typeof handler === "function") {
                handlerKey = handler;
            }

            prop = handlers.get(handlerKey);

            if (isUndefined(prop)) {
                prop = new TS.PropertyAccessor({dataSource: dataSource, propertyPath: propertyPath, handler: handler});
                handlers.add(handlerKey, prop);
            }
            return prop;
        }
    });
})();